import { useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import GameList from "../../components/GameList";
import ChatBox from "../../components/ChatBox";
import "./HomePage.css";

const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  return (
    <div className="home-page">
      <video 
        className="video-bg"
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/assets/bg-pc.mp4" type="video/mp4" />
      </video>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <GameList />
      
      {/* Chat Box */}
      <ChatBox />

      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomePage;
